// extracted by mini-css-extract-plugin
export default {"row":"WebsiteRow_row__KDJda","text":"WebsiteRow_text__osc3a"};